import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { BASE_URL } from '../urls';

const fetchResponses = async (limit, cursor, token, dispatch) => {
  dispatch({type: FETCH_NEXT_USER_RESPONSES});
  try {
    const response = await fetch(`${BASE_URL}/responses?limit=${limit}&cursor=${ cursor ? btoa(JSON.stringify(cursor)) : ""}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token
      }
    });
    const payload = await response.json();
    dispatch({type: USER_RESPONSES_FETCHED, payload});
  } catch(e) {
    console.error(e);
    alert("problem fetching response");
    throw e;
  }
}

const useResponses = (limit=12) => {
  const [page, setPage] = useState(0);
  const dispatch = useDispatch()
  const [didFetch, setDidFetch] = useState(false);
  let {items, cursor, fetching} = useSelector((state) => state.responses);
  let token = useSelector((state) => state.auth.token);

  const min = (page * limit) + 1;
  let max = (page + 1) * limit;
  if (max > items.length) {
    max = items.length;
  }
  if (!didFetch) {
    fetchResponses(limit, null, token, dispatch);
    setDidFetch(true);
  }
  return {
    responses: items.sort((a, b) => b.metadata.createdAt - a.metadata.createdAt).slice(min - 1, (min -1) + limit),
    min,
    max,
    fetching,
    hasMore: items.length > max || !!cursor,
    onNext: async () => {
      if (items.length > max && (!cursor || items[items.length - 1].metadata.id === cursor.id)) {
        setPage(page + 1);
      } else if (cursor) {
        await fetchResponses(limit, cursor, token, dispatch);
        setPage(page + 1);
      }
    },
    onPrevious: () => {
      if (page > 0) {
        setPage(page - 1);
      }
    }
  }
}

export default useResponses;

export const FETCH_NEXT_USER_RESPONSES = "FETCH_NEXT_USER_RESPONSES";
export const USER_RESPONSES_FETCHED = "USER_RESPONSES_FETCHED";
